<template>
  <div class="form-group">
    <label for="input-top">{{ fieldName }}{{ isMandatory ? '*' : '' }}</label>
    <input
      class="text-content"
      :class="{'error-text': !isValid || isExist}"
      id="input-top"
      type="text"
      :value="value"
      :disabled="disabled"
      @blur="$emit('getValue', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      placeholder="Placeholder" />
      <span v-if="isExist" :class="{error: isExist}">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [ String, Number, Array ]
    },
    fieldName: {
        type: String,
        default: 'Label'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: true
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    isExist: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style scoped lang="less">
@import '~@/assets/common.less';

.text-content {
  width: -webkit-fill-available;
}

.error {
  font-size: small;
  color: @red-52;
  display: block;
}

.error-text {
  border-color: @red-52;
}

.dark label {
  margin-bottom: 0 !important;
}
</style>